module.exports = __webpack_public_path__ + "static/img/dsk-home-bg.a27796f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-home-bg.jpg
// module id = 230
// module chunks = 1